import { WithTooltip } from '@infotech/base-components'
import { CRUD_PATH_PLURAL } from './constants'

import { ReactComponent as Sun } from "./sun.svg"

const Icon = WithTooltip({
  placement      : `right`,
  tooltip        : `Плановые участки (дневные)`,
  TargetComponent: Sun,
})

export default {
  id  : `dayStreetParts`,
  name: `Плановые участки (дневные)`,
  to  : `/${CRUD_PATH_PLURAL}`,
  icon: Icon,
  hide: (capabilities) => !capabilities[`sg.street-parts.day.access`],
}
